<template>
  <div class="register-wrapper">
    <div class="register-container">

      <!-- Logo -->
      <div class="register-logo">
        <img src="images/logo/logo.png" alt="Medicater logo">
      </div>

      <!-- Registration form -->
      <div class="register-card" v-if="mode == 'register'">
        <div class="register-header">
          <h2>Create Account</h2>
          <p>Fill in the details below to get started</p>
        </div>

        <form id="register-form" v-on:submit.prevent="register">

          <div class="input-group">
            <span class="input-icon"><i class="ft-mail"></i></span>
            <input type="email" placeholder="Email Address" required v-model="email">
          </div>

          <div class="input-row">
            <div class="input-group">
              <span class="input-icon"><i class="ft-user"></i></span>
              <input type="text" placeholder="First Name" required v-model="first_name">
            </div>
            <div class="input-group">
              <span class="input-icon"><i class="ft-user"></i></span>
              <input type="text" placeholder="Last Name" required v-model="last_name">
            </div>
          </div>

          <div class="input-group">
            <span class="input-icon"><i class="ft-phone"></i></span>
            <input type="text" placeholder="Mobile Number" required v-model="cellphone">
          </div>

          <div class="input-group">
            <span class="input-icon"><i class="ft-lock"></i></span>
            <input type="password" placeholder="Password" required v-model="password">
          </div>

          <div class="input-group">
            <span class="input-icon"><i class="ft-lock"></i></span>
            <input type="password" placeholder="Confirm Password" required v-model="confirm_password">
          </div>

          <div class="input-group input-group--select">
            <span class="input-icon"><i class="ft-briefcase"></i></span>
            <select required v-model="company_id">
              <option value="">Select Company</option>
              <option v-for="company in companies" v-bind:key="company.id" v-bind:value="company.id">{{ company.name }}</option>
            </select>
            <i class="ft-chevron-down select-arrow"></i>
          </div>

          <transition name="fade">
            <div class="error-box" v-if="errorMsg">
              <i class="ft-alert-circle"></i> {{ errorMsg }}
            </div>
          </transition>

          <button type="submit" class="register-btn">Create Account</button>

          <p class="signin-text">Already have an account? <router-link to="/login">Sign In</router-link></p>

        </form>
      </div>

      <!-- OTP confirmation -->
      <div class="register-card" v-if="mode == 'otp'">
        <div class="register-header">
          <div class="otp-icon">
            <i class="ft-message-square"></i>
          </div>
          <h2>Verify Your Number</h2>
          <p>An OTP has been sent to <strong>{{ cellphone }}</strong></p>
        </div>

        <form id="otp-form" v-on:submit.prevent="confirmOtp">

          <div class="input-group">
            <span class="input-icon"><i class="ft-hash"></i></span>
            <input type="text" placeholder="Enter OTP code" required v-model="code" autocomplete="one-time-code">
          </div>

          <transition name="fade">
            <div class="error-box" v-if="errorMsg2">
              <i class="ft-alert-circle"></i> {{ errorMsg2 }}
            </div>
          </transition>

          <button type="submit" class="register-btn">Verify OTP</button>

          <button type="button" class="resend-btn" v-on:click="resendOtp">
            <i class="ft-refresh-cw"></i> Resend OTP
          </button>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'register',
  data: function () {
    return {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      confirm_password: '',
      cellphone: '',
      company_id: '',
      companies: [],
      mode: 'register',
      code: '',
      errorMsg: '',
      errorMsg2: ''
    }
  },
  mounted: function () {
    var that = this
    this.$store.commit('SET_LAYOUT', 'AuthLayout')

    $.ajax({
      url: this.$config.apiUrl + 'basic/companies',
      type: 'get',
      success: function (data) {
        data.data.forEach(function (company) {
          that.companies.push({ id: company.id, name: company.name })
        })
      },
      error: function (data) {
        if (window.localStorage.getItem(this.url)) {
          var offlineData = JSON.parse(window.localStorage.getItem(this.url))
          this.success(offlineData)
        } else {
          swal({ text: 'Please connect to the internet', icon: 'info', button: 'Ok' })
        }
      }
    })
  },
  methods: {
    register: function () {
      var that = this
      this.errorMsg = ''

      if (this.password !== this.confirm_password) {
        this.errorMsg = 'Passwords do not match'
        return
      }
      if (this.company_id === '') {
        this.errorMsg = 'Please select a company'
        return
      }

      var data = {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        password: this.password,
        confirm_password: this.confirm_password,
        cellphone: this.cellphone,
        company_id: this.company_id,
        deviceId: window.localStorage.getItem('deviceId')
      }

      $.ajax({
        url: this.$config.apiUrl + 'basic/register',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (typeof data.success !== 'undefined' && data.success === true) {
            window.localStorage.setItem('user', JSON.stringify(data.data))
            window.localStorage.setItem('token', data.meta.token)
            that.sendOtp()
          } else {
            that.errorMsg = data.message
          }
        },
        error: function (data) {
          that.errorMsg = data.message
        }
      })
    },
    sendOtp: function () {
      this.mode = 'otp'
      $.ajax({
        url: this.$config.apiUrl + 'basic/resend_otp',
        type: 'post',
        data: JSON.stringify({ username: this.cellphone })
      })
    },
    confirmOtp: function () {
      var that = this
      this.errorMsg2 = ''

      $.ajax({
        url: this.$config.apiUrl + 'basic/verify_otp',
        type: 'post',
        data: JSON.stringify({ otp: this.code, username: this.cellphone }),
        success: function (data) {
          if (data.success === true) {
            that.$router.push('/')
          } else {
            that.errorMsg2 = 'Incorrect OTP. Please try again.'
          }
        },
        error: function () {
          that.errorMsg2 = 'Incorrect OTP. Please try again.'
        }
      })
    },
    resendOtp: function () {
      this.errorMsg2 = ''
      $.ajax({
        url: this.$config.apiUrl + 'basic/resend_otp',
        type: 'post',
        data: JSON.stringify({ username: this.cellphone }),
        success: function () {
          swal({ text: 'OTP has been resent.', icon: 'success', button: 'Ok' })
        }
      })
    }
  }
}
</script>

<style scoped>
.register-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #77d1f3;
  padding: 24px 16px;
}

.register-container {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* ── Logo ── */
.register-logo img {
  max-width: 160px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.25));
}

/* ── Card ── */
.register-card {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.register-header {
  text-align: center;
  margin-bottom: 24px;
}

.register-header h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a2e4a;
  margin: 0 0 6px;
}

.register-header p {
  font-size: 0.875rem;
  color: #8a9bb0;
  margin: 0;
}

/* OTP icon */
.otp-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, #e0f2fe, #bae6fd);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #1a587b;
  margin: 0 auto 14px;
}

/* ── Inputs ── */
.input-group {
  position: relative;
  margin-bottom: 12px;
}

.input-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.input-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #8a9bb0;
  font-size: 0.95rem;
  pointer-events: none;
  display: flex;
  align-items: center;
  z-index: 1;
}

.input-group input,
.input-group select {
  width: 100%;
  padding: 12px 14px 12px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #2d3748;
  background: #f8fafc;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  appearance: none;
  -webkit-appearance: none;
}

.input-group input:focus,
.input-group select:focus {
  border-color: #1a8a7a;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26, 138, 122, 0.12);
}

.input-group input::placeholder { color: #b0bcc8; }

.input-group--select .select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  color: #94a3b8;
  pointer-events: none;
}

/* ── Error ── */
.error-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  color: #c53030;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.85rem;
  margin-bottom: 14px;
}

/* ── Buttons ── */
.register-btn {
  width: 100%;
  padding: 13px;
  background: linear-gradient(135deg, #0f4c81, #1a8a7a);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: opacity 0.2s, transform 0.1s;
  margin-bottom: 10px;
}
.register-btn:hover { opacity: 0.92; }
.register-btn:active { transform: scale(0.98); }

.resend-btn {
  width: 100%;
  padding: 11px;
  background: #f8fafc;
  color: #475569;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s;
}
.resend-btn:hover { background: #f1f5f9; }

.signin-text {
  text-align: center;
  font-size: 0.85rem;
  color: #64748b;
  margin: 4px 0 0;
}
.signin-text a { color: #0f4c81; font-weight: 600; text-decoration: none; }
.signin-text a:hover { text-decoration: underline; }

/* Fade transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
